export const ENVIRONMENT = {
    DEVELOPMENT: "development",
    STAGING: "staging",
    PRODUCTION: "production"
};

export const getNodeEnv = () => _process.env.NODE_ENV;

export const isDevelopment = getNodeEnv() === ENVIRONMENT.DEVELOPMENT;

export const isStaging = getNodeEnv() === ENVIRONMENT.STAGING;

export const isProduction = getNodeEnv() === ENVIRONMENT.PRODUCTION;

export const derivedPublicPath = `${window.CONST?.remoteJsUrl || "https://localhost:" + _process.env.PORT}/dist/`;

export const isMobi = /Mobi/i.test(window.navigator.userAgent); // https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent | https://stackoverflow.com/a/45666491

export const isSafari =
    navigator.vendor &&
    navigator.vendor.indexOf("Apple") > -1 &&
    navigator.userAgent &&
    navigator.userAgent.indexOf("CriOS") == -1 &&
    navigator.userAgent.indexOf("FxiOS") == -1;

export const isViewedOnGhPages = window.location.href.indexOf("github.io/") > -1;

export const appUrlPrefix = "/ibs-kiosk";
